import { Link } from "react-router-dom";
import "./SmallPop.css";
import { useEffect } from "react";

export default function SmallPop(props) {
    
    useEffect(() => {
        const timer = setTimeout(() => {
            if (props.onClose) {
                props.onClose();
            }
        }, props.duration || 3000);

        return () => clearTimeout(timer);
    }, [props]);

    return <div id="small-pop">  
        <p>{props.text}</p>
        {props.link && <Link to={props.link.to}>
            {props.link.text}
        </Link>}
    </div>
}